<!-- 嵌入式-远程控制 -->
<template>
  <div>
    <el-card style="position: relative; z-index: 0; width: 100%">
      <div slot="header" class="clearfix" v-if="backVisible">
        <el-button @click="$router.back()" class="pull-left">
          <i class="fa fa-chevron-left fa-fw"></i> 返回 </el-button
        >&nbsp; <el-tag size="medium" v-if="productSN">{{ productSN }}</el-tag
        >&nbsp;
        <el-tag size="medium" v-if="stationName">{{ stationName }}</el-tag>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="产品控制" name="first">
          <div style="padding-bottom: 10px">
            <el-button type="success" @click="onSelectDeviceOnly()">
              <i class="fa fa-plus"></i> 选择产品
            </el-button>
          </div>
          <el-form :model="itemTab2" ref="itemform" label-width="100px">
            <el-form-item label="命令主题">
              <el-col :span="18">
                <el-input
                  v-model="topicOnly"
                  type="textarea"
                  :autosize="{ minRows: 1, maxRows: 10 }"
                  placeholder="命令主题"
                >
                </el-input>
                <span class="text-muted"
                  >您选择的产品为：{{ itemTab2.dci_device_sn.join(",") }}</span
                >
              </el-col>
              <el-col :span="6">
                <span
                  class="text-muted pad-x-xs pull-left"
                  style="font-size: 14px; line-height: 140%"
                >
                  默认命令主题为
                  <span class="text-danger bg-muted text-xs"
                    >&nbsp;产品编号/$cd&nbsp;</span
                  >
                  <br />仅能选择一个主题
                </span>
              </el-col>
            </el-form-item>
            <el-form-item label="控制时间">
              <el-input-number
                v-model="num"
                :min="0"
                :max="360"
                label="控制时间"
              ></el-input-number>
              <span
                class="text-muted pad-x-xs"
                style="font-size: 14px; line-height: 140%"
                >以分钟为单位</span
              >
            </el-form-item>
            <el-form-item label="控制类型">
              <el-checkbox-group v-model="itemTab2.Ports">
                <el-checkbox :label="Ports[0]">ssh</el-checkbox>
                <el-checkbox :label="Ports[1]">web</el-checkbox>
                <el-checkbox :label="Ports[2]">tel</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="命令质量" v-if="false">
              <el-radio-group v-model="itemTab2.Qos">
                <el-radio :label="0">QoS 0</el-radio>
                <el-radio :label="1">QoS 1</el-radio>
                <el-radio :label="2">QoS 2</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="text-center">
              <el-button type="primary" @click="onSendItemTab2"
                :disabled="sending">
                <i class="fa fa-paper-plane"></i> 远程控制
              </el-button>
              <el-button type="danger" @click="onStopItemTab2"
                :disabled="sending">
                <i class="fa fa-ban"></i> 停止转发
              </el-button>
              <!-- <el-button @click="onClearItemTab2()">
                  <i class="fa fa-plus"></i> 清 空
                </el-button> -->
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="产品自定义控制" name="second">
          <div style="padding-bottom: 10px">
            <el-button type="success" @click="onSelectDevice()">
              <i class="fa fa-plus"></i> 选择产品
            </el-button>
            <el-button @click="showGetCommandTab1()">
              <i class="fas fa-upload"></i> 加载命令
            </el-button>
            <!-- <el-button @click="showNewCommandTab1()">
              <i class="fas fa-download"></i> 新增命令
            </el-button> -->
          </div>
          <el-form :model="itemTab1" ref="itemform" label-width="100px">
            <el-form-item label="命令主题">
              <el-col :span="18">
                <el-input
                  v-model="topics"
                  type="textarea"
                  :autosize="{ minRows: 1, maxRows: 10 }"
                  placeholder="命令主题"
                >
                </el-input>
                <span class="text-muted"
                  >您选择的产品为：{{ itemTab1.dci_device_sn.join(",") }}</span
                >
              </el-col>
              <el-col :span="6">
                <span
                  class="text-muted pad-x-xs pull-left"
                  style="font-size: 14px; line-height: 140%"
                >
                  默认命令主题为
                  <span class="text-danger bg-muted text-xs"
                    >&nbsp;产品编号/$cd&nbsp;</span
                  >
                  <!-- <br />可使用回车输入多个主题同时发送 -->
                </span>
              </el-col>
            </el-form-item>
            <el-form-item label="命令内容" prop="Payload">
              <el-col :span="18">
                <el-input
                  v-model="itemTab1.Payload"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 10 }"
                  placeholder="命令内容"
                >
                </el-input>
              </el-col>
              <el-col :span="6">
                <span
                  class="text-muted pad-x-xs pull-left"
                  style="font-size: 14px; line-height: 140%"
                >
                  建议使用JSON格式的命令，系统下发JSON命令时会插入
                  <span class="text-danger bg-muted text-xs"
                    >&nbsp;$cdsn&nbsp;</span
                  >
                  作为命令的唯一编号。
                </span>
              </el-col>
            </el-form-item>
            <el-form-item label="命令质量" v-if="false">
              <el-radio-group v-model="itemTab1.Qos">
                <el-radio :label="0">QoS 0</el-radio>
                <el-radio :label="1">QoS 1</el-radio>
                <el-radio :label="2">QoS 2</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="text-center">
              <el-button
                type="primary"
                @click="onSendItemTab1()"
                :disabled="sending"
              >
                <i class="fa fa-paper-plane"></i> 发 送
              </el-button>
              <!-- <el-button @click="onClearItemTab1()">
                  <i class="fa fa-plus"></i> 清 空
                </el-button> -->
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="命令管理" name="third" v-if="getPermission()">
          <!--group: 业务组类型 0.嵌入式 1.工控，必传0 -->
          <CommandDiv group="0"></CommandDiv>
        </el-tab-pane>
        <el-tab-pane label="临时文件夹" name="fourth" v-if="getFilePermission()">
          <TempFile></TempFile>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 产品控制记录 -->
    <div v-if="activeName === 'first'">
      <el-card
        class="hover-color-change mar-t-md"
        style="position: relative; z-index: 0; width: 100%"
      >
        <div slot="header" class="clearfix">
          <span class="pull-left text-sm text-muted">
            <i class="fa fa-link"></i> 快捷命令
          </span>
        </div>
        <div>
          <el-button
            round
            plain
            v-for="item in itemListQuickCommand"
            :key="item.ID"
            @click="onSendQuickCommandClick(item)"
            :disabled="sending"
            type="success"
            size="small"
            :title="item.Desc"
            >{{ item.Name }}
          </el-button>
        </div>
      </el-card>

      <el-card
        class="mar-t-md"
        style="position: relative; z-index: 0; width: 100%"
      >
        <div slot="header" class="clearfix">
          <span class="pull-left text-sm text-muted">
            <i class="fa fa-fw fa-list-ol"></i> 端口关系&nbsp;
            <el-button
              type="text"
              title="刷新端口记录"
              @click="getItemListPorts()"
            >
              <i class="fa fa-sync"></i
            ></el-button>
          </span>
        </div>
        <div
          v-if="itemTab2.dci_device_id.length !== 1"
          class="text-center text-sm text-muted mar-btm"
        >
          仅在选择一个产品时显示其端口关系
        </div>
        <div v-else>
          <el-table :data="itemListPorts" v-loading="loading">
            <el-table-column prop="Port" label="端口号"></el-table-column>
            <el-table-column prop="IP" label="服务器IP"></el-table-column>
            <el-table-column
              prop="ServerPort"
              label="服务器端口号"
            ></el-table-column>
            <el-table-column prop="Name" label="名称"></el-table-column>
            <el-table-column prop="ExpireTime" label="剩余时间">
              <template slot-scope="{ row }">
                <span v-if="row.ExpireTime">
                  {{ parseInt(row.ExpireTime / 60) }}分钟{{
                    row.ExpireTime - parseInt(row.ExpireTime / 60) * 60
                  }}秒</span
                >
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.Port === 22">
                  <el-button @click="shellClick(scope.row)" type="text">
                    ssh
                  </el-button>
                </div>
                <div v-if="scope.row.Port === 80">
                  <el-button @click="WebClick(scope.row)" type="text">
                    web
                  </el-button>
                </div>
                <div v-if="scope.row.Port === 23">
                  <el-button @click="shellClick(scope.row)" type="text">
                    tel
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <el-card
        class="hover-color-change mar-t-md"
        style="position: relative; z-index: 0; width: 100%"
      >
        <div slot="header" class="clearfix">
          <span class="pull-left text-sm text-muted">
            <i class="fa fa-fw fa-list-ol"></i> 产品控制记录&nbsp;
            <el-button
              type="text"
              title="刷新控制记录"
              @click="getItemListTab2()"
            >
              <i class="fa fa-sync"></i
            ></el-button>
          </span>
        </div>
        <div
          v-if="itemTab2.dci_device_id.length !== 1"
          class="text-center text-sm text-muted mar-btm"
        >
          仅在选择一个产品时显示其控制记录
        </div>
        <div v-else>
          <el-table
            :data="itemListTab2"
            v-loading="loading"
            @cell-mouse-enter="hoverCell2"
            :highlight-current-row="true"
            :row-key="(row) => row.ID"
            :current-row-key="currentRowKey2"
          >
            <el-table-column
              prop="Topic"
              label="命令主题"
              width="200"
            ></el-table-column>
            <el-table-column prop="Payload" label="命令内容"></el-table-column>
            <el-table-column prop="Type" label="类型" width="140">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.Type === '返回'" type="success">
                  {{ scope.row.Type }}
                </el-tag>
                <el-tag v-else type="primary"> {{ scope.row.Type }} </el-tag>
              </template></el-table-column
            >
            <el-table-column
              prop="Person"
              label="操作人"
              width="80"
            ></el-table-column>
            <el-table-column prop="CreatedAt" label="时间" width="160">
              <template slot-scope="{ row }">
                <span v-if="row.CreatedAt">
                  {{ row.CreatedAt.replace("T", " ").substring(0, 19) }}</span
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="paginator">
            <el-pagination
              @current-change="onChangePageTab2"
              layout="total, prev, pager, next"
              :total="pagerTab2.total"
              :current-page="pagerTab2.page"
              :page-size="pagerTab2.size"
            >
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 产品自定义控制记录 -->
    <div v-if="activeName === 'second'">
      <el-card
        class="hover-color-change mar-t-md"
        style="position: relative; z-index: 0; width: 100%"
      >
        <div slot="header" class="clearfix">
          <span class="pull-left text-sm text-muted">
            <i class="fa fa-fw fa-list-ol"></i> 产品控制记录&nbsp;
            <el-select
              v-model="commSelect"
              placeholder="请选择产品SN"
              style="width: 200px"
              clearable
              @change="getItemListTab1"
            >
              <el-option
                v-for="sn in itemTab1.dci_device_sn"
                :key="sn"
                :label="sn"
                :value="sn"
              ></el-option> </el-select
            >&nbsp;
            <el-button
              type="text"
              title="刷新控制记录"
              @click="getItemListTab1()"
            >
              <i class="fa fa-sync"></i
            ></el-button>
          </span>
        </div>
        <div>
          <el-table
            :data="itemListTab1"
            v-loading="loading"
            @cell-mouse-enter="hoverCell1"
            :highlight-current-row="true"
            :row-key="(row) => row.ID"
            :current-row-key="currentRowKey1"
          >
            <el-table-column
              prop="Topic"
              label="命令主题"
              width="200"
            ></el-table-column>
            <el-table-column prop="Payload" label="命令内容"></el-table-column>
            <el-table-column prop="Type" label="类型" width="140">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.Type === '返回'" type="success">
                  {{ scope.row.Type }}
                </el-tag>
                <el-tag v-else type="primary"> {{ scope.row.Type }} </el-tag>
              </template></el-table-column
            >
            <el-table-column
              prop="Person"
              label="操作人"
              width="80"
            ></el-table-column>
            <el-table-column prop="CreatedAt" label="时间" width="160">
              <template slot-scope="{ row }">
                <span v-if="row.CreatedAt">
                  {{ row.CreatedAt.replace("T", " ").substring(0, 19) }}</span
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="paginator">
            <el-pagination
              @current-change="onChangePageTab1"
              layout="total, prev, pager, next"
              :total="pagerTab1.total"
              :current-page="pagerTab1.page"
              :page-size="pagerTab1.size"
            >
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>

    <ItemDevice :visible.sync="deviceVisible" @update="getDeviceSnTab1">
    </ItemDevice>
    <!-- <ItemCommand
      :commandVisibleProp.sync="commandVisible"
      :newCommandVisibleProp.sync="newCommandVisible"
      @update="getCommandTab1"
    >
    </ItemCommand> -->
    <ItemCommand
      :commandVisibleProp.sync="commandVisible"
      @update="getCommandTab1"
    >
    </ItemCommand>
    <ItemDeviceOnly :visible.sync="deviceOnlyVisible" @update="getDeviceSnTab2">
    </ItemDeviceOnly>
    <CompTerm
      :obj="connectData"
      :terminalVisibleProp.sync="termVisible"
    ></CompTerm>
    <ConnCommand
      :selectedRow="this.selectedRow"
      :editorVisibleProp.sync="editorVisible"
      @connectData="connectHandle"
    ></ConnCommand>

    <QuickCommand
      :command="quickItem"
      :quickSendInfo="quickSendInfo"
      :visible.sync="quickCommandVisible"
      @connectData="connectHandle"
      @form:saved="getItemListTab2"
    ></QuickCommand>
  </div>
</template>

<script>
import ItemDevice from "./index--device.vue";
import ItemCommand from "./index--command.vue";
import ItemDeviceOnly from "./index--device--only.vue";
import ConnCommand from "./ConnCommand.vue";
import CompTerm from "./CompTerm.vue";
import CommandDiv from "../../basic/commandManage/index.vue";
import QuickCommand from "../../basic/commandManage/quickcommand.vue";
import TempFile from "./index--tempfile.vue";

export default {
  components: {
    ItemDevice,
    ItemCommand,
    ItemDeviceOnly,
    ConnCommand,
    CompTerm,
    CommandDiv,
    QuickCommand,
    TempFile,
  },
  data() {
    return {
      sending: false,
      connectData: null,
      termVisible: false,
      editorVisible: false,
      selectedRow: null,
      Ports: [22, 80, 23],
      num: 120,
      activeName: "first",
      topics: "", // 主题
      topicOnly: "", // 单选主题
      itemListPorts: [],
      itemListTab1: [],
      itemListTab2: [],
      itemTab1: {
        Topics: [],
        dci_device_id: [], // 产品id数组
        dci_device_sn: [],
        Payload: "",
        Qos: 2,
      },
      itemTab2: {
        Topics: [],
        dci_device_id: [], // 产品id数组(单个)
        dci_device_sn: [],
        Qos: 2,
        ControlTime: "",
        Ports: [],
      },
      former: {
        DciDeviceID: "",
      },
      commSelect: "",
      pagerTab1: {
        total: 0,
        page: 1,
        size: 15,
      },
      pagerTab2: {
        total: 0,
        page: 1,
        size: 15,
      },
      deviceVisible: false,
      deviceOnlyVisible: false,
      commandVisible: false,
      // newCommandVisible: false,
      loading: false,
      // 设备控制记录高亮选中行的key值
      currentRowKey1: null,
      currentRowKey2: null,
      itemListQuickCommand: [], //快捷命令列表
      quickItem: {}, //点击的快捷命令
      quickSendInfo: {}, //快捷命令信息
      quickCommandVisible: false,
      backVisible: false, //是否显示返回按钮
      stationName: "",
      productSN: "",
    };
  },
  mounted() {
    if (this.$route.query.sn) {
      this.itemTab2.Topics = [];
      this.backVisible = true;
      this.productSN = this.$route.query.sn;
      this.stationName = this.$route.query.name;
      this.topicOnly = `${this.$route.query.sn}/$cd`;
      this.itemTab2.dci_device_sn = [`${this.$route.query.sn}`];
      this.itemTab2.dci_device_id = [this.$route.query.id - 0];
      this.itemTab2.Topics = [`${this.$route.query.sn}/$cd`];
      this.getItemListTab2();
      this.getItemListPorts();

      this.itemTab1.Topics = [];
      this.topics = `${this.$route.query.sn}/$cd`;
      this.itemTab1.dci_device_sn = [`${this.$route.query.sn}`];
      this.itemTab1.dci_device_id = [this.$route.query.id - 0];
      this.itemTab1.Topics = [`${this.$route.query.sn}/$cd`];
      this.getItemListTab1();
    }
    this.getQuickCommand();
  },
  methods: {
    connectHandle(data) {
      this.connectData = data;
      this.termVisible = true;
    },
    //获取快捷命令管理列表
    getQuickCommand() {
      this.$axios
        .get("command/list", {
          params: {
            where: {
              BusinessGroup: 0, //业务组类型 0.嵌入式 1.工控，必传0
              IsPublic: 1, //是否公开0:否  1:是
            },
            total: 0,
            page: 1,
            size: 100,
            order: ["name"],
          },
        })
        .then((response) => {
          this.itemListQuickCommand = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 获取产品控制列表
    getItemListTab1() {
      if (!this.itemTab1.dci_device_id.length) {
        this.$message.warning("请至少选择一个产品!");
        return;
      }
      let ids = [];
      if (this.commSelect !== "") {
        let index = this.itemTab1.dci_device_sn.indexOf(this.commSelect);
        ids.push(this.itemTab1.dci_device_id[index]);
      } else {
        ids = this.itemTab1.dci_device_id;
      }
      this.loading = true;
      this.$axios
        .get("dci/communication", {
          params: {
            ids: ids,
            ...this.pagerTab1,
            order: ["-created_at", "-id"],
          },
        })
        .then((response) => {
          this.itemListTab1 = response.data.data;
          this.pagerTab1 = _.pick(response.data, "size", "page", "total");
          if (this.pagerTab1.page > response.data.last) {
            this.pagerTab1.page = response.data.last;
            this.getItemListTab1();
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 获取产品端口记录
    getItemListPorts() {
      if (!this.itemTab2.dci_device_id.length) {
        this.$message.warning("请选择产品!");
        return;
      }
      this.loading = true;
      this.$axios
        .get("dci/communication/ports", {
          params: {
            SN: this.itemTab2.dci_device_sn[0],
          },
        })
        .then((response) => {
          this.itemListPorts = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    shellClick(row) {
      this.selectedRow = row;
      this.editorVisible = true;
    },
    WebClick(row) {
      // const url = `${window.location.hostname}:${row.ServerPort}`;
      const url = `106.14.169.68:${row.ServerPort}`;
      // url = 'http://www.baidu.com'; 用于测试
      window.open("http://" + url);
    },
    getItemListTab2() {
      if (!this.itemTab2.dci_device_id.length) {
        this.$message.warning("请选择产品!");
        return;
      }
      this.loading = true;
      this.$axios
        .get("dci/communication", {
          params: {
            where: {
              DciProductID: this.itemTab2.dci_device_id[0],
            },
            ...this.pagerTab2,
            order: ["-created_at", "-id"],
          },
        })
        .then((response) => {
          this.itemListTab2 = response.data.data;
          this.pagerTab2 = _.pick(response.data, "size", "page", "total");
          if (this.pagerTab2.page > response.data.last) {
            this.pagerTab2.page = response.data.last;
            this.getItemListTab2();
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 产品自定义控制-获取选中产品
    getDeviceSnTab1(options) {
      this.commSelect = "";
      this.itemTab1.Topics = [];
      this.itemTab1.dci_device_sn = options.map((e) => e.SN);
      this.itemTab1.dci_device_id = options.map((e) => e.ID);
      this.itemTab1.dci_device_sn.forEach((sn) => {
        this.itemTab1.Topics.push(`${sn}/$cd`);
      });
      this.topics = this.itemTab1.Topics.join("\n");

      this.getItemListTab1();
    },

    // 产品控制-获取选中产品
    getDeviceSnTab2(currentRow) {
      this.itemTab2.Topics = [];
      this.itemTab2.dci_device_sn = [currentRow.SN];
      this.itemTab2.dci_device_id = [currentRow.ID];
      //2022-07-28 数据库设计命令管理有title字段配置topics后缀，嵌入式暂不处理，都是&cd
      this.itemTab2.Topics.push(`${currentRow.SN}/$cd`);
      this.topicOnly = this.itemTab2.Topics.join("\n");
      this.getItemListTab2();
      this.getItemListPorts();
    },
    // 产品自定义控制-获取调用命令
    getCommandTab1(Payload) {
      this.itemTab1.Payload = Payload;
      // this.getItemListTab1();
    },
    onSelectDevice() {
      this.deviceVisible = true;
    },
    onSelectDeviceOnly() {
      this.deviceOnlyVisible = true;
    },
    showGetCommandTab1() {
      this.commandVisible = true;
    },

    // tab1翻页
    onChangePageTab1(page) {
      this.pagerTab1.page = page;
      this.getItemListTab1();
    },
    // tab2翻页
    onChangePageTab2(page) {
      this.pagerTab2.page = page;
      this.getItemListTab2();
    },
    // 产品自定义控制-发送命令
    onSendItemTab1() {
      if (!this.itemTab1.dci_device_id.length) {
        this.$message.warning("请至少选择一个产品!");
        return;
      }
      if (!this.itemTab1.Payload) {
        this.$message.warning("命令内容必填!");
        return;
      }

      this.sending = true;
      const data = {
        DciDeviceIDs: this.itemTab1.dci_device_id,
        Topics: this.itemTab1.Topics,
        Payload: this.itemTab1.Payload, // JSON.parse(this.item.Payload),
        Qos: this.itemTab1.Qos,
      };
      this.$axios
        .post("dci/communication/customcontrol", data)
        .then(() => {
          this.sending = false;
          this.$message.success("发送成功");
          this.getItemListTab1();
        })
        .catch(({ response }) => {
          this.sending = false;
          this.$sys.alarmResponse(response);
        });
    },
    //产品控制-远程控制
    onSendItemTab2() {
      this.itemTab2.ControlTime = this.num;
      if (!this.itemTab2.dci_device_id.length) {
        this.$message.warning("请选择产品!");
        return;
      }
      this.sending=true;
      const data = {
        DciDeviceIDs: this.itemTab2.dci_device_id,
        Topics: this.itemTab2.Topics,
        Qos: this.itemTab2.Qos,
        ControlTime: this.itemTab2.ControlTime,
        Ports: this.itemTab2.Ports,
      };
      this.$axios
        .post("dci/communication/control", data)
        .then(() => {
          this.sending=false;
          this.$message.success("发送成功");
          this.getItemListTab2();
          this.getItemListPorts();
        })
        .catch(({ response }) => {
          this.sending=false;
          this.$sys.alarmResponse(response);
        });
    },
    //产品控制-停止转发
    onStopItemTab2() {
      if (!this.itemTab2.dci_device_id.length) {
        this.$message.warning("请选择产品!");
        return;
      }
      this.sending=true;
      const data = {
        DciDeviceIDs: this.itemTab2.dci_device_id,
        Topics: this.itemTab2.Topics,
        Qos: this.itemTab2.Qos,
      };
      this.$axios
        .post("dci/communication/control/delete", data)
        .then(() => {
          this.sending=false;
          this.$message.success("操作成功");
          this.getItemListTab2();
          this.getItemListPorts();
        })
        .catch(({ response }) => {
          this.sending=false;
          this.$sys.alarmResponse(response);
        });
    },
    //产品控制-点击快捷命令按钮
    onSendQuickCommandClick(item) {
      if (!this.itemTab2.dci_device_id.length) {
        this.$message.warning("请选择产品!");
        return;
      }
      const data = {
        DciDeviceIDs: this.itemTab2.dci_device_id,
        Topics: this.itemTab2.Topics,
        Payload: item.Payload, // JSON.parse(this.item.Payload),
        Qos: 2,
      };
      //有额外参数
      if (item.ExtraParams != null && item.ExtraParams.length > 0) {
        this.quickItem = item;
        this.quickSendInfo = data;
        this.quickCommandVisible = true;
      } else {
        this.sending=true;
        //无额外参数，直接发送快捷命令
        this.$axios
          .post("dci/communication/customcontrol", data)
          .then(() => {
            this.sending=false;
            this.$message.success("发送成功");
            this.getItemListTab2();
          })
          .catch(({ response }) => {
            this.sending=false;
            this.$sys.alarmResponse(response);
          });
      }
    },

    // // 点击新增命令，展示自定义命令dialog
    // showNewCommandTab1() {
    //   this.newCommandVisible = true;
    // },
    // // 清空数据
    // onClearItemTab1() {
    //   this.itemTab1 = {
    //     Topics: [],
    //     dci_device_id: [], // 产品id数组
    //     dci_device_sn: [],
    //     Payload: "",
    //     Qos: 2,
    //   };
    // },
    // onClearItemTab2() {
    //   this.itemTab2 = {
    //     Topics: [],
    //     dci_device_id: [], // 产品id数组
    //     dci_device_sn: [],
    //     Payload: "",
    //     Qos: 2,
    //     ControlTime: 0,
    //   };
    // },

    // 设备控制记录table项hover时触发
    hoverCell1(row) {
      if (row.Topic.includes("$ds")) {
        this.currentRowKey1 = row.WithID;
      } else {
        this.currentRowKey1 = row.ID;
      }
    },
    hoverCell2(row) {
      if (row.Topic.includes("$ds")) {
        this.currentRowKey2 = row.WithID;
      } else {
        this.currentRowKey2 = row.ID;
      }
    },
    getPermission() {
      var has = false;
      if (this.$store.state.Auth.user.Permissions) {
        this.$store.state.Auth.user.Permissions.forEach((perm) => {
          if ("command-*" === perm.Obj + "-" + perm.Act) {
            has = true;
          }
        });
      }
      return has;
    },
    getFilePermission() {
      var has = false;
      if (this.$store.state.Auth.user.Permissions) {
        this.$store.state.Auth.user.Permissions.forEach((perm) => {
          if ("dci_communication_tempFile-*" === perm.Obj + "-" + perm.Act) {
            has = true;
          }
        });
      }
      return has;
    },
  },
};
</script>

<style scoped lang="scss" scoped>
.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 35px 30px 10px 30px;
  margin: -20px -20px 10px -20px;
}
.left {
  float: left;
  text-align: left;
  width: 20%;
}
.right {
  float: right;
  text-align: right;
  width: 80%;
}
#app {
  width: 100%;
  height: 100%;
  .el-table {
    // 看这里！！！！！！！！！！！！！！！！！！！！！！！！！！！！
    // 深度选择器，去除默认的padding
    /deep/ th {
      padding: 0 0 10 0;
      font-size: larger;
    }
  }
}
.noLabel .el-checkbox__label {
  display: none;
}
.hover-color-change .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #9df;
}
.hover-color-change .el-table__body tr.current-row > td {
  background-color: #9df;
}
</style>
